export default "__VITE_ASSET__DdoBQ1it__"